import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

initShopeepayReporter({ region: 'sg', project: 'shopeepay-sg' })
instrumentAxios(axios, 'shopeepay-sg')
